import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { default as pt } from 'prop-types';
import styles from './styles.scss';

export const VenueFilter = ({ venues, handleSelection, selectedVenue }) => {
  return (
    <Dropdown
      options={venues}
      value={selectedVenue}
      className={`${styles['venue']} test-venue-filter-dropdown`}
      type="venue"
      onChange={handleSelection}
    />
  );
};

VenueFilter.propTypes = {
  venues: pt.array.isRequired,
  selectedVenue: pt.oneOfType([pt.string, pt.number]),
  handleSelection: pt.func,
};



// WEBPACK FOOTER //
// ./src/common/components/filter/VenueFilter.js